import React from 'react';
import PropTypes from 'prop-types';
import { getFormattedDate } from 'utils/dateTime';
import Table, { Row, Column } from 'components/molecules/TableList';
import Toggle from 'components/utilities/Toggle';
import { IconButton } from 'components/atoms/Button/Button';
import Icon from 'components/atoms/Icon';
import { clock, chevronDown } from 'components/atoms/Icon/icons';
import { translate } from 'utils/translate';

import * as styles from './ProductOpeningHours.scss';

const ProductOpeningHours = props => {
  const { openingHours, showInitial } = props;
  const groupedOpeningHours = Object.values(
    openingHours.slice(0, showInitial).reduce((result, currentObject) => {
      const val1 = currentObject['startDay'];
      const val2 = currentObject['endDay'];
      const val3 = currentObject['description'];
      result[val1 + ' ' + val2 + ' ' + val3] =
        result[val1 + ' ' + val2 + ' ' + val3] || [];
      result[val1 + ' ' + val2 + ' ' + val3].push(currentObject);
      return result;
    }, {}),
  );
  return (
    <Toggle
      on={groupedOpeningHours.length === 1}
      render={({ on, setOn }) => (
        <React.Fragment>
          <Table
            className={styles.table}
            caption={translate('/product/openingHours')}
          >
            {groupedOpeningHours
              .slice(0, !on ? 1 : groupedOpeningHours.length)
              .map((value, i) => (
                <React.Fragment key={i}>
                  <Row>
                    <Column heading colSpan={3} className={styles.bgGrey}>
                      {getFormattedDate(value[0].startDay, 'd')}.{' '}
                      {getFormattedDate(value[0].startDay, 'MMM yyyy')}
                      {!!value[0].endDay && (
                        <React.Fragment>
                          {'–'}
                          {getFormattedDate(value[0].endDay, 'd')}.{' '}
                          {getFormattedDate(value[0].endDay, 'MMM yyyy')}
                        </React.Fragment>
                      )}
                    </Column>
                  </Row>
                  {value.map(
                    (hour, index) =>
                      !!hour.openingTimes && (
                        <Row
                          key={`openinghours_${hour.startDay}_${hour.endDay}_${
                            hour.description
                          }_${index + 1}`}
                        >
                          <Column width="160px" verticalCenter={false}>
                            {hour.nameOfStartDay}
                            {hour.nameOfEndDay &&
                              hour.nameOfEndDay !== hour.nameOfStartDay &&
                              `–${hour.nameOfEndDay}`}
                          </Column>
                          <Column verticalCenter={false}>
                            <em>{value[0].description}</em>
                          </Column>
                          <Column
                            align="right"
                            width="126px"
                            verticalCenter={false}
                          >
                            {hour.openingTimes.map((oTime, k) => (
                              <React.Fragment key={k}>
                                <time dateTime={new Date(oTime)}>
                                  {getFormattedDate(oTime, 'p')}
                                  {!!hour.closingTimes[k] &&
                                    getFormattedDate(
                                      hour.closingTimes[k],
                                      '–p',
                                    )}
                                </time>
                                {hour.openingTimes.length > 1 &&
                                  k < hour.openingTimes.length - 1 &&
                                  ', '}
                              </React.Fragment>
                            ))}
                          </Column>
                        </Row>
                      ),
                  )}
                </React.Fragment>
              ))}
          </Table>
          {!on && (
            <p className={styles.showMore}>
              <IconButton
                onClick={setOn}
                iconAfter={chevronDown}
                className={styles.showMoreDates}
                transparent
              >
                {translate('/product/showMoreDates')}
              </IconButton>
            </p>
          )}
        </React.Fragment>
      )}
    />
  );
};
ProductOpeningHours.displayName = 'ProductOpeningHours';
ProductOpeningHours.propTypes = {
  openingHours: PropTypes.array,
  showInitial: PropTypes.any,
  product: PropTypes.any,
};
ProductOpeningHours.defaultProps = {};

export default ProductOpeningHours;
